import {Component, OnInit} from '@angular/core';
import {DocumentModel} from '../../../models/document.model';
import {LoadingController, ModalController} from '@ionic/angular';
import {NewDocumentService} from '../../../services/new-document.service';
import {StateManagerService} from '../../../services/state-manager.service';
import {CollectionsNames} from '../../../definitions/collections-names';
import {TestConnectionService} from '../../../services/test-connection.service';
import {RefreshdatabaseService} from '../../../services/database/refreshdatabase.service';
import {GeneralService} from '../../../services/general.service';
import {DocumentTypes} from '../../../definitions/document-types';
import {ValidateDocumentService} from '../../../services/validate-document.service';
import {GeneralSaveDocumentService} from '../../../services/general-save-document.service';
import {SiteModel} from '../../../models/site.model';
import {DetaillineDTOModel} from '../../../models/detaillineDTO.model';
import {LokijsService} from '../../../services/database/lokijs.service';
import {RefreshLiveDetailLinesService} from '../../../services/refresh-live-detail-lines.service';
import {ScannedTodayService} from '../../../services/scanned-today.service';
import {PersistScannedBarcodesService} from '../../../services/persist-scanned-barcodes.service';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {BarcodeOptions} from '../../../definitions/barcode-options';

@Component({
    selector: 'app-check-hospital-stock',
    templateUrl: './check-hospital-stock.component.html',
    styleUrls: ['./check-hospital-stock.component.scss'],
})
export class CheckHospitalStockComponent implements OnInit {

    documentTemp: DocumentModel;
    loading: any;
    detailLinesInHospital: DetaillineDTOModel[];
    notCheckedLinesInHospital: number;
    totalLinesInHospital: number;
    sites: SiteModel[];

    constructor(public modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private stateManagerService: StateManagerService,
                private testConnectionService: TestConnectionService,
                private refreshdatabaseService: RefreshdatabaseService,
                private generalService: GeneralService,
                private loadingController: LoadingController,
                private docTypes: DocumentTypes,
                private validateDoc: ValidateDocumentService,
                private generalSaveDocument: GeneralSaveDocumentService,
                private loki: LokijsService,
                private collectionsNames: CollectionsNames,
                private refreshLiveDetailLinesService: RefreshLiveDetailLinesService,
                private scannedTodayService: ScannedTodayService,
                private barcodeScanner: BarcodeScanner,
                private barcodeOptions: BarcodeOptions,
                private persistScannedBarcodesService: PersistScannedBarcodesService) {
    }

    async ngOnInit() {
        this.documentTemp = this.newDocumentService.genNewDocument();
        await this.refreshLiveDetailLinesService.refreshLiveDetailLines();
        const currentCustomer = this.stateManagerService.getCollection(this.collectionsNames.CONFIGURATION).currentCustomer;
        if (currentCustomer) {
            this.listenCustomer(currentCustomer);
        }
    }

    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.site = new SiteModel();
        this.documentTemp.detailLines = new Array<DetaillineDTOModel>();
        this.sites = this.stateManagerService.getCollection(this.collectionsNames.SITE).filter(site => {
            return site.cust === event.cod;
        });
        this.loadLiveLinesForHospital();
    }

    cancelCheck() {
        this.modalController.dismiss();
    }

    async scanItem() {
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {
            console.log(barcode.text);
            this.handleScanResult(barcode.text);
        }).catch(err => {
            console.log(err);
        });
        // const modal = await this.modalController.create({
        //     component: ScanBarcodeCheckWardComponent,
        //     backdropDismiss: false,
        //     cssClass: 'modal-fullscreen',
        //     componentProps: {
        //         document: this.documentTemp,
        //         reconciliation: true
        //     }
        // });
        // modal.onDidDismiss().then(() => {
        // });
        // return await modal.present();
    }

    async handleScanResult(barcode) {
        console.log('Scan Result');
        console.log(event);
        const equipment = this.detailLinesInHospital.find(line => {
            if (line.barcode === barcode) {
                this.persistScannedBarcodesService.persistBarcode(barcode);
                line.isChecked = true;
            }
            return line.barcode === barcode;
        });
        if (!equipment) {
            await this.generalService.createToast('Equipment Not Found');
        }
    }

    loadLiveLinesForHospital() {
        this.detailLinesInHospital = this.loki.getCollection(this.collectionsNames.LIVEDETAILLINES).chain().data();
        console.log(this.detailLinesInHospital);
        this.detailLinesInHospital = this.detailLinesInHospital.filter(line => line.custId === this.documentTemp.customer.id);
        this.totalLinesInHospital = this.detailLinesInHospital.length;
        this.detailLinesInHospital = this.scannedTodayService.check(this.detailLinesInHospital);
        // Sites are cast into an object to avoid n squared
        const sitesObj = {};
        for (const site of this.sites) {
            sitesObj[site.id] = site.name;
        }
        console.log(sitesObj);
        this.detailLinesInHospital.map(line => {
            line.siteDescription = sitesObj[line.site];
        });
        this.notCheckedLinesInHospital = this.detailLinesInHospital.length;
        console.log(this.detailLinesInHospital);
    }

    updateDateFrom() {
        this.detailLinesInHospital.forEach(line => {
            line.fromDate = new Date().toISOString();
            if (line.isChecked) {
                line.toDate = new Date().toISOString();
                this.persistScannedBarcodesService.persistBarcode(line.barcode);
            }
        });
    }
}
